import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { uploadImage } from "../../utils/helpers/fileupload";
import { getSubjectTeacher } from "../../store/slices/subjectteacher";
import { getDiaryNote, updatediarynote } from "../../store/slices/diaryNote";
import { getStudent } from "../../store/slices/student";

// icons
import { MdDelete, MdFileCopy, } from "react-icons/md";
import { FcGallery } from "react-icons/fc";

const requiredMessages = {
    standardId: "Please select standard",
    sectionId: "Please select section",
    subjectId: "Please select subject",
    diaryNote: "Please enter description",
};



export default function EditDiaryNote() {
    const { id } = useParams();

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.data?.accessToken;
    const teacherId = user?.data?.teacherId;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [rawData, setRawData] = useState([]);
    const [standards, setStandards] = useState([]);
    const [sections, setSections] = useState([]);
    const [subjects, setSubjects] = useState([]);

    const [students, setStudents] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [studentLoading, setStudentLoading] = useState(false);

    const [errors, setErrors] = useState({});
    const [file, setFile] = useState(null);
    const [existingFile, setExistingFile] = useState([]);

    const [formData, setFormData] = useState({
        standardId: "",
        sectionId: "",
        subjectId: "",
        diaryNote: "",
    });

    /* ---------------- > teacher mapping  */
    useEffect(() => {
        const fetchTeacherData = async () => {
            const res = await dispatch(getSubjectTeacher(teacherId)).unwrap();
            const data = res?.data || [];

            setRawData(data);

            const uniqueStandards = [
                ...new Map(
                    data.map((i) => [i.standardId._id, i.standardId])
                ).values(),
            ];
            setStandards(uniqueStandards);
        };

        fetchTeacherData();
    }, [dispatch, teacherId]);

    /* fetch diarynote by id  <---------------- */
    useEffect(() => {
        const fetchDiaryById = async () => {
            try {
                const res = await dispatch(getDiaryNote({ id, teacherId })).unwrap();
                const note = Array.isArray(res?.data) ? res.data[0] : res?.data;

                if (!note) {
                    toast.error("Diary note not found");
                    return;
                }

                const standardId = note.standardId?._id;
                const sectionId = note.sectionId?._id;
                const subjectId = note.subjectId?._id;

                setFormData({
                    standardId,
                    sectionId,
                    subjectId,
                    diaryNote: note.diaryNote || "",
                });

                setSelectedStudents(note.students?.map((s) => s._id) || []);
                setExistingFile(note.files || []);

                // sections =================== >
                const sec = rawData

                    .filter((i) => i.standardId._id === standardId)

                    .map((i) => i.sectionId);

                setSections([...new Map(sec.map((s) => [s._id, s])).values()]);

                // subjects ====================== >
                const sub = rawData

                    .filter(
                        (i) =>
                            i.standardId._id === standardId &&
                            i.sectionId._id === sectionId
                    )
                    .map((i) => i.subjectId);

                setSubjects([...new Map(sub.map((s) => [s._id, s])).values()]);

                // students
                setStudentLoading(true);

                const stuRes = await dispatch(

                    getStudent({ standardId, sectionId })

                ).unwrap();

                setStudents(stuRes?.data || []);

            } catch (err) {
                toast.error("Failed to load diary note");

            } finally {
                setStudentLoading(false);

            }

        };

        if (rawData.length && id) {
            fetchDiaryById();
        }
    }, [dispatch, id, rawData]);

    /* ---------------- handlers ---------------- */
    const handleStandardChange = (e) => {
        const standardId = e.target.value;

        setFormData({
            standardId,
            sectionId: "",
            subjectId: "",
            diaryNote: "",
        });

        const sec = rawData
            .filter((i) => i.standardId._id === standardId)
            .map((i) => i.sectionId);

        setSections([...new Map(sec.map((s) => [s._id, s])).values()]);
        setSubjects([]);
        setStudents([]);
        setSelectedStudents([]);
    };

    const handleSectionChange = async (e) => {
        const sectionId = e.target.value;

        setFormData((prev) => ({
            ...prev,
            sectionId,
            subjectId: "",
        }));

        const sub = rawData
            .filter(
                (i) =>
                    i.standardId._id === formData.standardId &&
                    i.sectionId._id === sectionId
            )
            .map((i) => i.subjectId);

        setSubjects([...new Map(sub.map((s) => [s._id, s])).values()]);

        setStudentLoading(true);
        const res = await dispatch(
            getStudent({ standardId: formData.standardId, sectionId })
        ).unwrap();

        setStudents(res?.data || []);
        setSelectedStudents([]);
        setStudentLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((p) => ({ ...p, [name]: value }));
        setErrors((p) => ({ ...p, [name]: "" }));
    };

    const handleStudentToggle = (sid) => {
        setSelectedStudents((prev) =>
            prev.includes(sid) ? prev.filter((i) => i !== sid) : [...prev, sid]
        );
    };

    const handleSelectAllStudents = () => {
        setSelectedStudents(
            selectedStudents.length === students.length
                ? []
                : students.map((s) => s._id)
        );
    };

  const handleFileChange = (e) => {
  const selectedFile = e.target.files[0];
  if (!selectedFile) return;

  
  if (existingFile.length >= 3) {
    toast.error("You can upload maximum 3 files only");
    e.target.value = "";
    return;
  }

  const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
  if (!allowedTypes.includes(selectedFile.type)) {
    toast.error("Only PDF, JPG, PNG files are allowed");
    e.target.value = "";
    return;
  }

  if (selectedFile.size > 2 * 1024 * 1024) {
    toast.error("File must be under 2MB");
    e.target.value = "";
    return;
  }

  setFile(selectedFile);
};


    const validateForm = () => {
        let errs = {};
        Object.keys(requiredMessages).forEach((k) => {
            if (!formData[k]) errs[k] = requiredMessages[k];
        });
        setErrors(errs);
        return Object.keys(errs).length === 0;
    };

    /* ------>>>>>>> submit  */
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            let uploadedFiles = [...existingFile];

            if (file instanceof File) {
                const uploadedUrl = await uploadImage(file, token);
                uploadedFiles.push(uploadedUrl);
            }

            const payload = {
                id,
                teacherId,
                ...formData,
                students: selectedStudents,
                files: uploadedFiles,
            };

            await dispatch(updatediarynote(payload)).unwrap();
            toast.success("Diary note updated successfully");
            navigate("/teacher/diarynote");
        } catch {
            toast.error("Failed to update diary note");
        }
    };



    // file type
    const getFileIcon = (file) => {
        if (file.endsWith(".pdf")) return <MdFileCopy size={15} />;
        if (file.match(/\.(jpg|jpeg|png)$/)) return <FcGallery size={15} />;
        return "📎";
    };

    const handleRemoveExistingFile = (fileUrl) => {
        setExistingFile((prev) => prev.filter((f) => f !== fileUrl));
    };


    return (
        <Card className="an-card">
            <Card.Header className="an-header">
                <h5>Update Diary Note</h5>
            </Card.Header>

            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                        <Col md={4}>
                            <Form.Label>Standard</Form.Label>
                            <Form.Select
                                value={formData.standardId}
                                onChange={handleStandardChange}
                            >
                                <option value="">Select Standard</option>
                                {standards.map((s) => (
                                    <option key={s._id} value={s._id}>
                                        {s.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Label>Section</Form.Label>
                            <Form.Select
                                value={formData.sectionId}
                                onChange={handleSectionChange}
                            >
                                <option value="">Select Section</option>
                                {sections.map((s) => (
                                    <option key={s._id} value={s._id}>
                                        {s.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Label>Subject</Form.Label>
                            <Form.Select
                                name="subjectId"
                                value={formData.subjectId}
                                onChange={handleChange}
                            >
                                <option value="">Select Subject</option>
                                {subjects.map((s) => (
                                    <option key={s._id} value={s._id}>
                                        {s.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>

                        {students.length > 0 && (
                            <Card className="mt-3">
                                <Card.Header>
                                    <Form.Check
                                        type="checkbox"
                                        label="Select All Students"
                                        checked={selectedStudents.length === students.length}
                                        onChange={handleSelectAllStudents}
                                    />
                                </Card.Header>
                                <Card.Body style={{ maxHeight: 250, overflowY: "auto" }}>
                                    {students.map((s) => (
                                        <Form.Check
                                            key={s._id}
                                            type="checkbox"
                                            label={s.name}
                                            checked={selectedStudents.includes(s._id)}
                                            onChange={() => handleStudentToggle(s._id)}
                                        />
                                    ))}
                                </Card.Body>
                            </Card>
                        )}

                        <Col md={6}>
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="diaryNote"
                                value={formData.diaryNote}
                                onChange={handleChange}
                                style={{ height: "6rem", resize: "none" }}
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Label>Uploaded Files</Form.Label>

                            {/* Existing files list */}
                            {existingFile.length > 0 && (
                                <div className="mb-2  mx-2 d-flex align-items-center">
                                    {existingFile.map((fileUrl, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                marginBottom: "6px",
                                                backgroundColor:"whitesmoke",
                                                borderRadius:"5px",
                                                marginRight:"5px",
                                                padding:"3px"
                                            }}
                                        >    
                                            {/* filetype */}
                                            <span style={{color:"#6f42c1"}}>{getFileIcon(fileUrl)}</span>

                                            <a href={fileUrl} target="_blank" rel="noreferrer" style={{ color: "#2563eb", fontWeight: 500, fontSize: "12px" }}>
                                                 File {index + 1}
                                            </a>

                                            <span style={{ cursor: "pointer", color: "red", fontSize: "12px" }} onClick={() => handleRemoveExistingFile(fileUrl)} title="Remove file">
                                                <MdDelete size={15} />
                                            </span>
                                            
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Upload new file */}
                            <Form.Control
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={handleFileChange}
                                disabled={existingFile.length >= 3}
                            />

                            <small className="text-muted">
                                You can remove existing files or upload new ones.
                            </small>
                        </Col>


                    </Row>

                    <div className="an-actions mt-4">
                        <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-submit">
                            Update
                        </button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
}
